<template>
  <div class="container">
    <router-link to="/" class="box">
      <div class="icon">
        <img class="icon" src="@/assets/icon/home.svg" :alt="$t('randevu.header.home_alt')" />
      </div>
    </router-link>

    <router-link to="/portal" class="box">
      <div class="icon">
        <img class="icon" src="@/assets/icon/navigation/mobiluygulamalar.svg" :alt="$t('randevu.header.portal_alt')" />
      </div>
    </router-link>  

    <div class="logo"><span style="font-weight: 500;">{{ $t('randevu.header.title_strong') }}</span> {{ $t('randevu.header.title_rest') }}</div>  

    <img class="icon-question" src="./icons/nedir.svg" :alt="$t('randevu.header.how_to_use_alt')" @click="openModal" />

    <div v-if="isModalOpen" class="modal-overlay" @click="handleOverlayClick">
      <div ref="modalContent" class="modal-content" :style="modalStyle" @click.stop>
        <div class="close-div">
          <button class="close-button" @click="closeModal">X</button>
        </div>  

        <div class="content">
          <h2 class="modal-title">{{ $t('randevu.header.welcome_title') }}</h2>
          
          <p class="modal-text">{{ $t('randevu.header.welcome_intro_pre') }}<strong>"{{ $t('randevu.header.services_strong') }}"</strong>{{ $t('randevu.header.and') }}<strong>"{{ $t('randevu.header.experts_strong') }}"</strong>{{ $t('randevu.header.welcome_intro_post') }}
          </p>
        
          <ul class="modal-list">
            <li><strong>{{ $t('randevu.header.services_label') }}</strong> {{ $t('randevu.header.services_desc') }} <em>{{ $t('randevu.header.services_example') }}</em> {{ $t('randevu.header.services_example_suffix') }}</li>
            <li><strong>{{ $t('randevu.header.experts_label') }}</strong> {{ $t('randevu.header.experts_desc') }}</li>
          </ul>
        
          <p class="modal-text">{{ $t('randevu.header.future_intro') }}
          </p>
        
          <ul class="modal-list-future">
            <li>{{ $t('randevu.header.future_1') }}</li>
            <li>{{ $t('randevu.header.future_2') }}</li>
          </ul>
        
          <p class="modal-text">
            {{ $t('randevu.header.regards') }} 
          </p>
        </div>
        

      </div>
    </div>
  </div> 
</template>

<script>
export default {
  data() {
    return {
      isModalOpen: false,
      modalStyle: {
        transform: "translateY(100%)",
        transition: "transform 0.3s ease-in-out",
      }
    };
  },
  mounted() {
    const modalSeen = localStorage.getItem('modalSeen');
    if (!modalSeen) {
      this.openModal(); 
      localStorage.setItem('modalSeen', 'true');
    }
  },
  methods: {
    openModal() {
      this.isModalOpen = true;
      this.modalStyle.transform = "translateY(0%)";
    },
    closeModal() {
      this.isModalOpen = false;
      this.modalStyle.transform = "translateY(100%)";
    },
    handleOverlayClick() {
      this.closeModal();
    }
  }
};
</script>


<style scoped>
.container {
  display: flex;
  gap: 5px;
  justify-content: center;
  align-items: center; 
  margin: 1rem 0;
}

.box {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5em;
  min-width: 4em;
  min-height: 4em;
  border-radius: 8px;
  text-decoration: none;
  background-color: #050505;
  transition: transform 0.2s;
  color: #b5b5b5;
  font-size: 1.2em;
  font-weight: 300;
  cursor: pointer;
  border-bottom: 3px solid transparent;
}

.box:first-child {
  min-width: 5em;
} 
.box:hover {
  transform: scale(1.05);
  color: white;
  box-shadow: 0 5px 12px rgba(0, 104, 42, 0.2);
} 

.icon {
  min-width: 2em;
  max-height: 1.5em;
  opacity: 0.8;
}

.box:hover .icon {
  opacity: 1;
}

.logo {
  font-size: 1.4rem;
  font-weight: 200;
}

@media (max-width: 768px) {
  .container{
    justify-content: flex-start;
}
}

.icon-question {
  width: 1.6rem;
  height: 1.6rem;
  transition: transform 0.3s ease-in-out;
  cursor: pointer;
  margin-left: 0.6em;
}

.icon-question:hover {
  transform: scale(1.2);
}


/* Modal yapısı */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: flex-end;
  z-index: 9999;
}

.modal-content {
  margin-top: 12rem;
  width: 100%;
  max-width: 1080px;
  background: linear-gradient(45deg, #020202, #080808, #030b0b);
  border-radius: 10px 10px 0 0;
  border-top: 1px solid #022121;
  border-left: 1px solid #022121;
  border-right: 1px solid #022121;
  box-shadow: 0 -4px 8px rgba(0, 0, 0, 0.5);
  padding: 1rem;
  overflow-y: auto;
  max-height: 80vh; 
}
.content{  padding-bottom: 5rem;}

.close-div {
  position: sticky;
  border-radius: 15px 15px 0 0;
  top: 0;
  display: flex;
  justify-content: flex-end;
  z-index: 1;
  padding: 0.5rem;
}

.close-button {
  background-color: #000000;
  color: #ffffff;
  padding: 0.8rem;
  min-width: 3rem;
  max-width: 3rem;
  border-radius: 2rem;
  opacity: 0.8;
  border: 1px solid #444444;
  cursor: pointer;
  transition: transform 0.3s ease;
}
 
.close-button:hover {
  opacity: 1;
  transform: scale(1.1);
}




.modal-title {
  font-size: 1.5em;
  margin-bottom: 1rem;
  color: #ffffff;
  text-align: center;
}

.modal-text {
  font-size: 0.85rem;
  line-height: 1.5;
  margin-bottom: 1rem;
  color: #cccccc;
}

.modal-list, .modal-list-future {
  font-size: 0.75rem;
  line-height: 1.4;
  color: #dddddd;
  margin-bottom: 1rem;
  padding-left: 1.5rem;
}

.modal-list-future {
  opacity: 0.8;
  font-style: italic;
}

.modal-list li, .modal-list-future li {
  margin-bottom: 0.5rem;
}

</style>
